import DelBox from '../comps/DelBox';
import AddDepart from '../models/AddDepart';
import { useEffect, useState, useRef } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import AddTest from '../models/AddTest';
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Swal from 'sweetalert2';

const TestDetailes = () => {
  const DEFAULT_PAGE_SIZE = 10; // default rows per page

  const [searchTerm, setSearchTerm] = useState('');
  const [showOptions, setShowOptions] = useState(false);
  const dropdownRef = useRef(null);

  const [formData, setFormData] = useState({
    l1: [],
    cats: [],
    test_cat: '',
    page_no: 0, // still kept for any other usage
    alertMsg: '',
    alertMsgTyp: '',
    search_key: '',
    isAlert: false,
  });

  const [isAdmin, setIsAdmin] = useState(false);
  const [ldata, setLdata] = useState(null);
  const [editItem, setEditItem] = useState(null);

  // DataTable client-side pagination state
  const [currentPage, setCurrentPage] = useState(1); // DataTable pages are 1-based
  const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_PAGE_SIZE);

  const initData = async () => {
    const storedData = sessionStorage.getItem("ldata");
    const userData = JSON.parse(sessionStorage.getItem("ldata") || "{}");
    const roleId = userData?.role_id;
    if (roleId === 1 || roleId === "1") {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }

    if (!storedData) return;

    try {
      const fd = new FormData();
      fd.append('page_no', formData.page_no + "");
      fd.append('search_key', formData.search_key + "");
      fd.append('test_user', 1 + "");
      fd.append('test_cat', formData.test_cat);
      const response = await axios.post(AppConst.BASE_URL + AppConst.getTestListUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.data && response.data.status) {
        const records = response.data.records || [];
        setFormData(prev => ({ ...prev, l1: records }));
      } else {
        setFormData(prev => ({ ...prev, l1: [] }));
      }
    } catch (error) {
      console.error("initData getTestListUrl error:", error);
      setFormData(prev => ({ ...prev, l1: [] }));
    }

    // fetch categories
    try {
      const fd1 = new FormData();
      fd1.append('cat_type', "department");
      fd1.append('page_no', "none");
      fd1.append('search_key', "");
      fd1.append('par_by', 1 + "");
      const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd1, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (response.data && response.data.status) {
        const records = response.data.records || [];
        setFormData(prev => ({ ...prev, cats: records }));
      }
    } catch (error) {
      console.error("initData getCatListUrl error:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const delItem = async (editItem) => {
    if (!editItem) return;
    const fd = new FormData();
    fd.append('test_id', editItem.test_id + "");
    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.delTestUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (response.data && response.data.status) {
        initData();
        toast.success('Deleted Successfully');
      } else {
        toast.error(response.data?.message || "Delete failed");
      }
    } catch (error) {
      console.error("delItem error:", error);
      toast.error("Server error while deleting");
    }
  };

  const handleAddDepart = () => {
    setFormData(prev => ({ ...prev, page_no: 0 }));
    initData();
  };

  useEffect(() => {
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setLdata(parsed);
      initData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.test_cat]);

  // Keep server-search but also show client-side filtered results
  const filteredList = (formData.l1 || []).filter(item => {
    if (!formData.search_key) return true;
    const q = formData.search_key.toString().toLowerCase();
    return (item.test_name || "").toString().toLowerCase().includes(q) ||
      (item.cat_name || "").toString().toLowerCase().includes(q);
  });

  useEffect(() => {
    // Close dropdown when clicked outside
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const filteredCats = (formData.cats || []).filter(item =>
    item.cat_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (cat) => {
    setFormData(prev => ({ ...prev, test_cat: cat.cat_id }));
    setSearchTerm(cat.cat_name);
    setShowOptions(false);
  };

  // Export filteredList to PDF (export all filtered rows)
  const exportPDF = () => {
    const doc = new jsPDF();
    const tableColumn = ["SN", "Test Name", "Department", "Price"];
    const tableRows = [];

    (filteredList || []).forEach((item, index) => {
      tableRows.push([
        index + 1,
        item.test_name || "-",
        item.cat_name || "-",
        item.test_price !== undefined && item.test_price !== null ? String(item.test_price) : "-"
      ]);
    });

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 20,
      theme: 'grid',
      headStyles: { fillColor: [64, 81, 137], textColor: [255, 255, 255], fontSize: 10 },
      bodyStyles: { fontSize: 9 },
      styles: { cellPadding: 3 },
      margin: { left: 8, right: 8 }
    });

    doc.save("TestDetails.pdf");
  };

  // DataTable columns
  const columns = [
    {
      name: '',
      cell: (row) => (
        <div style={{ display: 'flex', gap: 8 }}>
          <button
            type="button"
            disabled={!isAdmin}
            style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
            onClick={() => {
              setEditItem(row);
              document.getElementById("addbt453")?.click();
            }}
            className="btn btn-warning btn-sm"
          >
            <i className="ri-pencil-fill fs-16"></i>
          </button>

          {/* <button
            type="button"
            disabled={!isAdmin}
            style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
            onClick={() => {
              Swal.fire({
                title: 'Are you sure?',
                text: "This test will be permanently deleted!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#6c757d',
                confirmButtonText: 'Yes, delete it!',
              }).then((result) => {
                if (result.isConfirmed) {
                  delItem(row);
                }
              });
            }}
            className="btn btn-danger btn-sm"
          >
            <i className="ri-delete-bin-5-fill fs-16"></i>
          </button> */}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      width: '120px'
    },
    {
      name: 'SN',
      // compute continuous serial based on DataTable pagination state
      cell: (row, rowIndex) => ((currentPage - 1) * rowsPerPage) + (rowIndex || 0) + 1,
      width: '70px'
    },
    {
      name: 'Name',
      selector: row => row.test_name || '-',
      sortable: true,
      wrap: true,
      grow: 2,
    },
    {
      name: 'Department',
      selector: row => row.cat_name || '-',
      sortable: true,
      width: '200px'
    },
    {
      name: 'Price',
      selector: row => (row.test_price !== undefined && row.test_price !== null) ? String(row.test_price) : '-',
      sortable: true,
      right: true,
      width: '140px'
    }
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#f8f9fb',
        color: '#405189',
        fontSize: '14px',
        fontWeight: '600'
      }
    },
    rows: {
      style: {
        minHeight: '48px'
      }
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">

        <div className="row">
          <div className="col-lg-12">
            <div className="card" id="orderList">
              <div className="card-header border-0">
                <div className="row align-items-center gy-3">
                  <div className="col-sm">
                    <h5 className="card-title mb-0">Test Details</h5>
                  </div>
                  <div className="col-sm-auto">
                    <div className="d-flex gap-1 flex-wrap">
                      <button id="addbt453" style={{ display: "none" }} type="button" className="btn btn-success add-btn" data-bs-toggle="modal" data-bs-target="#showModal"></button>

                      <button type="button" className="btn btn-success add-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          setEditItem(null);
                          document.getElementById("addbt453").click();
                        }}
                      >
                        <i className="ri-add-line align-bottom me-1"></i> Add Test
                      </button>

                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={exportPDF}
                      >
                        <i className="ri-file-download-line align-bottom me-1"></i> Export PDF
                      </button>

                      <button className="btn btn-soft-danger" id="remove-actions">
                        <i className="ri-delete-bin-2-line"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-body border border-dashed border-end-0 border-start-0">
                <form>
                  <div className="row g-3">
                    <div className="col-xxl-3 col-sm-3">
                      <div className="search-box">
                        <input
                          className="form-control search"
                          name="search_key"
                          onChange={(e) => {
                            const value = e.target.value;
                            setFormData((prev) => ({ ...prev, search_key: value, page_no: 0 }));
                            initData();
                          }}
                          value={formData.search_key}
                          placeholder="Search by name"
                          type="text"
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>

                    <div className="col-xxl-3 col-sm-3">
                      <div>
                        <div ref={dropdownRef} style={{ position: 'relative', width: '100%' }}>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Type Test Type"
                            value={searchTerm}
                            onChange={(e) => {
                              setSearchTerm(e.target.value);
                              setShowOptions(true);
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Backspace") {
                                e.preventDefault();
                                setSearchTerm('');
                              }
                            }}
                            onFocus={() => setShowOptions(true)}
                            required
                          />

                          {showOptions && filteredCats.length > 0 && (
                            <div
                              className="dropdown-menu show"
                              style={{
                                display: 'block',
                                width: '100%',
                                position: 'absolute',
                                zIndex: 1000,
                                maxHeight: '200px',
                                overflowY: 'auto',
                              }}
                            >
                              {filteredCats.map(item => (
                                <button
                                  type="button"
                                  key={item.cat_id}
                                  className="dropdown-item"
                                  onClick={() => handleSelect(item)}
                                >
                                  {item.cat_name}
                                </button>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                  </div>
                </form>
              </div>

              <br />

              <div className="card-body pt-0">
                <div>
                  <div className="table-responsive table-card mb-1">
                    <DataTable
                      columns={columns}
                      data={filteredList}
                      pagination
                      paginationPerPage={rowsPerPage}
                      onChangePage={(page) => {
                        setCurrentPage(page);
                      }}
                      onChangeRowsPerPage={(newPerPage, page) => {
                        setRowsPerPage(newPerPage);
                        // When rows per page changes, move to first page for clarity
                        setCurrentPage(1);
                      }}
                      highlightOnHover
                      pointerOnHover
                      responsive
                      customStyles={customStyles}
                      noHeader
                      striped
                      persistTableHead
                    />
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="pagination-wrap hstack gap-2">
                      {/* DataTable built-in pagination used */}
                    </div>
                  </div>

                </div>

                <AddTest item={editItem} onAddDepart={handleAddDepart} />
                <DelBox />
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestDetailes;
